/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type UpdateOrderMutationVariables = Types.Exact<{
	input: Types.UpdateOrderRequest;
}>;

export type UpdateOrderMutation = {
	__typename?: "Mutation";
	updateOrder:
		| { __typename?: "OrderInProgressResponse"; _?: boolean | null }
		| {
				__typename?: "OrderSuccessResponse";
				order: {
					__typename?: "Order";
					orderId: string;
					status: Types.OrderStatus;
					type: Types.OrderType;
					fiatId: string;
					assetId?: string | null;
					price: { __typename?: "CurrencyAmount"; value: string };
					amount: { __typename?: "CurrencyAmount"; value: string };
					createdAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
					failedAt?: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number } | null;
				};
		  };
};

export const UpdateOrderDocument = gql`
	mutation updateOrder($input: updateOrderRequest!) {
		updateOrder(request: $input) {
			... on OrderSuccessResponse {
				order {
					orderId
					status
					type
					fiatId
					assetId
					price {
						value
					}
					amount {
						value
					}
					createdAt {
						iso8601
						unixTimestamp
					}
					failedAt {
						iso8601
						unixTimestamp
					}
				}
			}
			... on OrderInProgressResponse {
				_
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class UpdateOrderGQLService extends Apollo.Mutation<UpdateOrderMutation, UpdateOrderMutationVariables> {
	document = UpdateOrderDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
